module.exports = __webpack_public_path__ + "img/hart.1a10e533.png";